import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class AccountingJournal  {
    _originalTypeClassName = "zERP.BO.AccountingJournal";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
AccountingJournal.translate = translateService;
}
this.JournalID = null;
this.Name = null;
this.Description = null;
this.isGeneral = false;
this.Prefix = null;
this.NextSerialNumber = 1;
this.MaxDateInJournal = null;
this.FinalNextSerialNumber = null;
this._key = this.JournalID = 0; 
}

static translate: TranslateService;
_key: any;
private _JournalID:any;
get JournalID(): any {
    return this._JournalID;
  }
set JournalID(value: any) {
    this._JournalID = value;
    this._key = value;
  }
Name:any;
Description:any;
isGeneral:any;
Prefix:any;
NextSerialNumber:any;
MaxDateInJournal:any;
FinalNextSerialNumber:any;
Ledger:any;
NEWJournal:any;
static setLedger = ($this, value) => {
var oldValue = $this.Ledger;
$this.Ledger = value;
if (value != null) {
if (oldValue != null) {
Domain.Ledger.removeJournals(oldValue, $this);
}
Domain.Ledger.addJournals(value, $this);
}
}
static setNEWJournal = ($this, value) => {
var oldValue = $this.NEWJournal;
$this.NEWJournal = value;
if (value != null) {
}
}


static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.JournalID == null || $this.JournalID == 0;
            }


}